<template>

<app-wrapper>

    <app-text>

        <app-group v-html="page.business_incentives_content" />

        <app-group :bordered="true">

            <app-input-toggle :expand="true" :label="page.business_incentives_enabled_label" v-model="inputs.enabled" :errored="errored.enabled" :options="options.enabled" />
            <app-input-toggle :expand="true" :label="page.business_incentives_type_label" v-model="inputs.type" :errored="errored.type" :options="options.type" />
            <app-input-toggle :expand="true" :label="page.business_incentives_length_label" v-model="inputs.length" :errored="errored.length" :options="options.length" />
            <app-input-text :label="page.business_incentives_name_label" v-model="inputs.name" :errored="errored.name" :placeholder="page.business_incentives_name_placeholder" />
            <app-input-text :multiline="true" :label="page.business_incentives_text_label" v-model="inputs.text" :errored="errored.text" :placeholder="page.business_incentives_text_placeholder" />
            <app-input-image :label="page.business_incentives_image_label" v-model="inputs.image" :errored="errored.image" v-on:change="inputs.imageRaw = arguments[0]" :placeholder="page.business_incentives_image_placeholder" />
        
        </app-group>

        <app-group :row="true" :center="true">

            <app-button :fixed="true" :success="is.saved" :fail="is.errored" :text="page.business_incentives_button_save" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />

        </app-group>

    </app-text>

</app-wrapper>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

    mixins: [mixinForm],
    
	data: function() {

		return {
            stayAfterSave: true,
			inputs: {
                enabled: 0,
                type: 0,
                length: 0,
                name: '',
                text: '',
                image: '',
                imageRaw: ''
            },
            options: {
                enabled: {
                    0: 'Off',
                    1: 'On'
                },
                type: {
                    1: 'Day(s)',
                    2: 'Week(s)',
                    3: 'Month(s)'
                },
                length: {
                    1: 1,
                    2: 2,
                    3: 3,
                    4: 4,
                    5: 5,
                    6: 6
                }
            },
			rules: {
				type: {
					required: true
				},
				length: {
					required: true
				},
				name: {
					required: true
				},
				text: {
					required: true
				}
			}
		}

    },

	methods: {

		resetValues: function() {

            this.inputs.enabled = this.session.business.incentive.enabled
            this.inputs.type = this.session.business.incentive.type
            this.inputs.length = this.session.business.incentive.length
            this.inputs.name = this.session.business.incentive.name
            this.inputs.text = this.session.business.incentive.text
            this.inputs.image = this.session.business.incentive.image
            this.inputs.imageRaw = ''
                
		},

		onSaveClick: function() {

			this.save('account/incentives', this.inputs)

		}

	}

}

</script>

<style scoped>

.prices-settings {
    margin-bottom: 20px;
}

.prices-settings-button {
    margin-top: 10px;
}

</style>